module.exports = __webpack_public_path__ + "Nunito-Regular.6198e4056babec12dec4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/Nunito-Regular.ttf
// module id = 1378
// module chunks = 2